import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Component, Inject, PLATFORM_ID, HostListener } from '@angular/core';

interface NavLink {
    label: string;
    path: string;
}

@Component({
    selector: 'app-main-header',
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive],
    templateUrl: './main-header.component.html',
    styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent {

    public isMobileMenuOpen = false;
    public isScrolled = false;
    private isBrowser!: boolean;

    navLinks: NavLink[] = [
        { label: 'How It Works', path: '/how-it-works' },
        { label: 'Past Results', path: '/proof' },
        { label: 'FAQ', path: '/faq' },
        { label: 'Pricing', path: '/pricing' },
        { label: 'Contact Us', path: '/contact' },
    ];

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll() {
        if (this.isBrowser) {
            this.isScrolled = window.scrollY >= window.innerHeight * 0.6;
        }
    }
    toggleMobileMenu(): void {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }
}
